export class AdjuntoModel {
  id?: number;
  nombre?: string;
  tamanio?: string;
  tipo?: string;
  activo?: boolean;
  file?: any;
  token?: string;
}
